import { kebabCase } from 'lodash'

const generateMapImageUrl = ({
  width = 600,
  height = 400,
  zoom = 7,
  country = 'united-kingdom',
  locality = null,
  region = null,
  kmRadius = null,
  listingRef = null
}) => {
  const mapImageBaseUrl = `${process.env.VUE_APP_LEGACY_API_BASE_URL}/maps.get?HID=sellmylivestock`

  // If we provide listingRef then Pete will work out all the location dancing for us
  if (listingRef) {
    return `${mapImageBaseUrl}&ListingRef=${listingRef}&Width=${width}&Height=${height}&Zoom=${zoom}`
  } else {
    country = kebabCase(country)

    if (region) {
      region = kebabCase(region)

      // Sometimes we don't have locality (e.g mass imported listings for events)
      if (locality) {
        locality = `${kebabCase(locality)},${region}`
      } else {
        locality = region
      }
    }

    return `${mapImageBaseUrl}&Country=${country}&Locality=${locality}&Width=${width}&Height=${height}&Zoom=${zoom}&KmRadius=${kmRadius}`
  }
}

export default generateMapImageUrl
